import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setToast } from '../app/appSlice';




export const  useNetwork = () => { 
    const [isOnline, setNetwork] = useState(window.navigator.onLine);
    const dispatch = useDispatch()
  
    useEffect(() => {
      window.addEventListener("offline", () =>
        setNetwork(window.navigator.onLine)
      );
    },[]);

    useEffect(() => {
      if(!isOnline) {
        dispatch(setToast({
          content:`Attention ! Vous n'avez plus de connexion veuillez vous reconnecter`,
          life:300000,
          severity:"info",
          title:"Perte de connexion",

        }))
      }
    },[isOnline])
  
    return isOnline;
  }

